import { render, staticRenderFns } from "./add-banner.vue?vue&type=template&id=4ea9fa44"
import script from "./add-banner.vue?vue&type=script&lang=ts"
export * from "./add-banner.vue?vue&type=script&lang=ts"
import style0 from "./add-banner.vue?vue&type=style&index=0&id=4ea9fa44&prod&lang=stylus"
import style1 from "./add-banner.vue?vue&type=style&index=1&id=4ea9fa44&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports